import React from "react";
import AddressContent from "./address-content.jsx";
import HourContent from "./hour-content.jsx";
import ScheduleGarrisonUtils from "../utils/schedulegarrison-utils.jsx";

const ActivityRows = ({ activityId, activity, isUpdate }) => {

    const activityData = ScheduleGarrisonUtils.isDiffObject(activity) ? activity : { old: {}, new: activity };

    const current = activityData.new || {};
    const previous = activityData.old || {};

    const currentHours = current.hours ?? {};
    const previousHours = previous.hours ?? {};

    const currentAddress = current.address ?? {};
    const previousAddress = previous.address ?? {};

    return (
        <tbody key={activityId}>

            <ScheduleGarrisonUtils.Row
                isUpdate={isUpdate}
                label="Tipo do horário"
                value={!isUpdate ? current.hours?.type : undefined}
                newValue={isUpdate ? ScheduleGarrisonUtils.getNew(current.hours?.type) : current.hours?.type}
                oldValue={isUpdate ? ScheduleGarrisonUtils.getOld(current.hours?.type) : previous.hours?.type}
            />

            <HourContent
                hours={isUpdate ? { new: currentHours, old: previousHours } : currentHours}
                type={currentHours.type ?? previousHours.type}
                isUpdate={isUpdate}
            />

            <ScheduleGarrisonUtils.Row
                isUpdate={isUpdate}
                label="Duração"
                value={!isUpdate ? current.duration : undefined}
                newValue={isUpdate ? ScheduleGarrisonUtils.getNew(current.duration) : current.duration}
                oldValue={isUpdate ? ScheduleGarrisonUtils.getOld(current.duration) : previous.duration}
            />

            <ScheduleGarrisonUtils.Row
                isUpdate={isUpdate}
                label="Natureza"
                value={!isUpdate ? current.reason : undefined}
                newValue={isUpdate ? ScheduleGarrisonUtils.getNew(current.reason) : current.reason}
                oldValue={isUpdate ? ScheduleGarrisonUtils.getOld(current.reason) : previous.reason}
            />

            <ScheduleGarrisonUtils.Row
                isUpdate={isUpdate}
                label="Prioridade"
                value={!isUpdate ? current.priority : undefined}
                newValue={isUpdate ? ScheduleGarrisonUtils.getNew(current.priority) : current.priority}
                oldValue={isUpdate ? ScheduleGarrisonUtils.getOld(current.priority) : previous.priority}
            />

            <AddressContent
                address={isUpdate ? { new: currentAddress, old: previousAddress } : currentAddress}
                isUpdate={isUpdate}
            />

            <ScheduleGarrisonUtils.Row
                isUpdate={isUpdate}
                label="Descrição"
                value={!isUpdate ? current.description : undefined}
                newValue={isUpdate ? ScheduleGarrisonUtils.getNew(current.description) : current.description}
                oldValue={isUpdate ? ScheduleGarrisonUtils.getOld(current.description) : previous.description}
            />

        </tbody>
    );
};

const ActivitiesContent = ({ activities, isUpdate = false }) => {
    if (!activities) return null;

    const activityEntries = ScheduleGarrisonUtils.getActivities(activities, isUpdate);

    if (!activityEntries.length) return null;

    return (
        <tr className="bg-white activities-content-table">
            <td colSpan={4}>
                <table className="w-full">
                    <thead>
                        <tr className="text-left">
                            <th colSpan={isUpdate ? 3 : 2}>
                                Atividades
                            </th>
                        </tr>

                        <tr>
                            <th style={{ width: "30%" }} />
                            <th style={{ width: isUpdate ? "35%" : "70%" }} />
                            { isUpdate && (
                                <th style={{ width: "35%" }}/>
                            )}
                        </tr>
                    </thead>

                    { activityEntries.map(([activityId, activity], index) => (
                        <React.Fragment key={activityId}>
                            <ActivityRows
                                activityId={activityId}
                                activity={activity}
                                isUpdate={isUpdate}
                            />

                            { index < activityEntries.length - 1 && (
                                <tbody>
                                    <tr>
                                        <td colSpan={isUpdate ? 3 : 2}>
                                            <div className="chart-divisor"/>
                                        </td>
                                    </tr>
                                </tbody>
                            )}
                        </React.Fragment>
                    ))}
                </table>
            </td>
        </tr>
    );
};

export default ActivitiesContent;